/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { errorResponseSchema } from "./errorResponseSchema.ts";
import { guestAddressSchema } from "./guestAddressSchema.ts";
import { patchedGuestAddressRequestSchema } from "./patchedGuestAddressRequestSchema.ts";

export const deliveryAddressesPartialUpdatePathAddressIdSchema = z.uuid();

export const deliveryAddressesPartialUpdateStatus200Schema = guestAddressSchema;

export const deliveryAddressesPartialUpdateStatus400Schema = errorResponseSchema;

export const deliveryAddressesPartialUpdateResponseSchema = z.union([
	deliveryAddressesPartialUpdateStatus200Schema,
	deliveryAddressesPartialUpdateStatus400Schema,
]);

export const deliveryAddressesPartialUpdateDataSchemaJson = patchedGuestAddressRequestSchema.optional();

export const deliveryAddressesPartialUpdateDataSchemaXml = patchedGuestAddressRequestSchema.optional();

export const deliveryAddressesPartialUpdateDataSchema = z.union([deliveryAddressesPartialUpdateDataSchemaJson, deliveryAddressesPartialUpdateDataSchemaXml]);
